import { Answer } from '@/models/Answer';

export type AnswerContentKind = 'text' | 'image';

export type AnswerContentSource = Pick<
  Answer,
  'text' | 'mediaFile' | 'mediaLink' | 'altText'
>;

const MIME_PREFIX_KIND: Record<string, AnswerContentKind> = {
  'image/': 'image',
};

export function resolveAnswerContentKind(
  answer: AnswerContentSource,
): AnswerContentKind {
  const url = answer.mediaFile?.url ?? answer.mediaLink;
  if (!url) return 'text';
  const mimetype = answer.mediaFile?.mimetype ?? '';
  const match = Object.entries(MIME_PREFIX_KIND).find(([prefix]) =>
    mimetype.startsWith(prefix),
  );
  return match?.[1] ?? 'image';
}
